import { MonthIntervalTypes, SortByType } from '../models/hotel-reviews';
export const DEFAULT_REPORTER_NAME = 'Аноним';
export const DEFAULT_SOURCES = [0, 1, 2, 3, 4];
export const DEFAULT_OFFSET = 0;
export const DEFAULT_REVIEW_AMOUNT_ON_PAGE = 5;
export const DEFAULT_TAGS: number[] = [];
export const DEFAULT_MONTH_INTERVALS: MonthIntervalTypes[] = [
    {
        from: 1,
        to: 12,
    },
];
export const DEFAULT_SORT_BY = SortByType.Newest;
export const DEFAULT_RATING_FILTER = [ 0, 1, 2 ];
export const DEFAULT_ADDITIONAL_RATING = {
        Room: 0,
        PriceQuality: 0,
        Location: 0,
        Service: 0,
        Clean: 0,
        Meal: 0,
      };

export const INIT_PAYLOAD = {
    offset: DEFAULT_OFFSET,
    amount: DEFAULT_REVIEW_AMOUNT_ON_PAGE,
    sources: DEFAULT_SOURCES,
    monthIntervals: DEFAULT_MONTH_INTERVALS,
    tags: DEFAULT_TAGS,
    sortBy: DEFAULT_SORT_BY,
    ratingType: DEFAULT_RATING_FILTER,
};

export const DEFAULT_REVIEWS_OVERVIEW = {
    amountBySeasons: {
        Summer: 0,
        Spring: 0,
        Winter: 0,
        Fall: 0,
    },
    amountByRatingType: {
        Good: 0,
        Medium: 0,
        Bad: 0,
    },
    reviewsWithPhotoAvailable: 0,
    reviewsWithDetailedTextAvailable: 0,
    reviewsWithDetailedRatingsAvailable: 0,
    averageReviewsRating: 0,
    additionalRatingsAverage: DEFAULT_ADDITIONAL_RATING,
    additionalRatingsCount: DEFAULT_ADDITIONAL_RATING,
    tagsCount: {}
};

export const DEFAULT_REVIEWS_AMOUNT_BY_GRADE = {
    Good: 0,
    Medium: 0,
    Bad: 0,
};
